module.exports = __webpack_public_path__ + "static/media/quote-dunning-selfinsight.847541ce.png";